import React, { useEffect, useRef } from 'react';

import { MenuItemProps } from 'editor/src/component/Menu/type';
import TextStyleModifiedBar from 'editor/src/component/TextStyleControl/TextStyleModifiedBar';

import styles from './index.module.scss';

/**
 * GAPI-61895: the toolbar item for "<Style> · Modified [Update all n texts] [Reset]". Empty (no
 * width) unless the selected text follows a style and was edited away from it; styles are
 * assigned from the Text tab.
 */
function TextStyleModifiedItem({ refresh }: Pick<MenuItemProps, 'refresh'>) {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  // The toolbar lays its items out by measured width: re-measure when the bar comes or goes.
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper || typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    let width = wrapper.offsetWidth;
    const observer = new ResizeObserver(() => {
      if (wrapper.offsetWidth !== width) {
        width = wrapper.offsetWidth;
        refreshRef.current?.();
      }
    });
    observer.observe(wrapper);
    return () => observer.disconnect();
  }, []);

  return (
    <span className={styles.wrapper} ref={wrapperRef}>
      <TextStyleModifiedBar className={styles.modifiedBar} />
    </span>
  );
}

export default React.memo(TextStyleModifiedItem) as React.FC<MenuItemProps>;
